import { useState } from "react";

export type FaqEntry = { q: string; a: string };

export default function FaqAccordion({ items }: { items: FaqEntry[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-300 border border-background-300 rounded-lg overflow-hidden bg-background-100">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-6 py-4 md:py-5 hover:bg-background-200/50 transition-colors"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                  {item.q}
                </span>
                <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 md:px-6 pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed max-w-3xl">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}